.features-type-3 {
  text-align: center;
}

.features-type-3__heading-column {
  @include desktop-lg {
    margin-left: auto;
    margin-right: auto;
  }
}

.features-type-3__heading {
  margin-bottom: 28px;

  @include desktop {
    margin-bottom: 32px;
  }

  @include desktop-md {
    margin-bottom: 40px;
  }

  @include desktop-lg {
    margin-bottom: 60px;
  }

  .me-heading {
    // max-width: 300px;
    margin-left: auto;
    margin-right: auto;

    @include desktop {
      max-width: 582px;
    }

    @include desktop-md {
      max-width: 828px;
    }

    @include desktop-lg {
      max-width: 924px;
    }
  }
}

.features-type-3__cards {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);

  @include desktop {
    flex-flow: row wrap;
    gap: var(--spacing-xl);
  }
}

.features-type-3__card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-align: left;
  width: 100%;

  @include desktop {
    width: calc(50% - var(--spacing-xl) / 2);
  }

  &--green,
  &--violet {
    .features-type-3__card-image {
      align-items: flex-end;
    }
  }
}

.features-type-3__card-image {
  padding: var(--spacing-lg) var(--spacing-lg) 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  overflow: hidden;
  border-radius: var(--radius-size-lg);

  @include desktop {
    padding: var(--spacing-3xl) var(--spacing-3xl) 0;
    min-height: 280px;
  }

  .picture {
    max-width: 100%;
    max-height: 140px;
    width: auto;
    height: auto;
    background: transparent;

    @include desktop {
      max-height: 220px;
    }

    img {
      max-height: 140px;
      width: auto;
      height: auto;
      object-fit: contain;
      filter: drop-shadow(0 8px 24px rgb(0 0 0 / 8%));

      @include desktop {
        max-height: 220px;
      }
    }
  }
}

.features-type-3__card-content {
  padding: var(--spacing-lg) 0;

  @include desktop {
    padding: var(--spacing-xl) 0;
  }
}

.features-type-3__card-title {
  margin-bottom: var(--spacing-xs);

  @include desktop {
    margin-bottom: var(--spacing-sm);
  }
}

// Color variants
.features-type-3__card--yellow {
  .features-type-3__card-image {
    background: #fffaeb;
  }
}

.features-type-3__card--green {
  .features-type-3__card-image {
    background: #ebfff2;
  }
}

.features-type-3__card--violet {
  .features-type-3__card-image {
    background: #f5f3ff;
  }
}

.features-type-3__card--pink {
  .features-type-3__card-image {
    background: #fff5f8;
  }
}
